import {buildProjectApiUrl} from "api/configuration";
import {http} from "api/http";

export const getTerritoriesData = (codes: string[]): Promise<Record<string, Record<string, number[][][]>>> => {
    return http.get(
        buildProjectApiUrl(`/geozones/territories/geodata?codes=${codes.join(",")}`),
        "Une erreur est survenue"
    );
};
